import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { setWebViewAfterKeyBoard } from '../../../JS/setWebView'

const DeviceRegPassword = (props) => {

    const { t } = props
    const [passwordInput, setPasswordInput] = React.useState("");
    const [error, setError] = React.useState(false);

    const handleProceed = (event) => {
        event.preventDefault();
        setError(false);

        if (passwordInput == props.ecpPassword) {
            props.next();
        } else {
            setError(true);
        }
    }

    return (
        <div id="connectorReg" class="form">
            <form onSubmit={handleProceed} style={{ color: "black" }}>
                <div className="form-item" style={{ color: "inherit" }}>
                    <label for="enter-password" style={{ color: "inherit" }}>{props.stringConst.enterPassword}</label>
                    <input
                        type="number"
                        name="enter-password"
                        pattern="[0-9][A-Z]{3}"
                        onChange={(e) => { setPasswordInput(e.target.value); setError(false) }}
                        value={passwordInput}
                        style={{ width: "100%", color: "inherit" }}
                        onBlur={(event) => { setWebViewAfterKeyBoard(event) }}
                    />
                    {error && <p style={{ color: "red" }}>*The password is incorrect</p>}
                </div>

                <div className="form-controls">
                    <button type="submit" id="devRegPassNext" className="primary">{props.stringConst.proceed}</button>
                    <button className="secondary" onClick={() => props.back()}>{props.stringConst.cancel}</button>
                </div>
            </form>

        </div>
    )
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        ecpPassword: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.SETTING_ACTIVITY_PASSWORD : null,
    }
}

export default connect(mapStateToProps, {})(withTranslation('translations')(DeviceRegPassword));